import { useState, useEffect } from "react";

export function useOperatingSystem() {
  const [os, setOs] = useState<"mac" | "windows" | "other">("other");

  useEffect(() => {
    const detectOS = () => {
      const platform = navigator.platform?.toLowerCase() || "";
      const userAgent = navigator.userAgent?.toLowerCase() || "";

      if (platform.includes("mac") || userAgent.includes("mac")) {
        setOs("mac");
      } else if (platform.includes("win") || userAgent.includes("windows")) {
        setOs("windows");
      } else {
        setOs("other");
      }
    };

    detectOS();
  }, []);

  return os;
}
